/**
 * @file 项目主入口
 * @author lixiaobin (lixiaobin@huatu.com)
 */

import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import * as echarts from 'echarts'
import toast from 'library/functions/toast'
import router from './router'
import store from './store'
import auth from '@/common/plugins/auth'
import commPlugin from '@/common/plugins/comm'
import authConfig from '@/common/config/auth'
import qs from 'qs'
import axios from 'axios'

// 路由守卫配置
import { setupRouter } from '@/common/plugins/router'
// 全局组件注册
import { setupComponents } from '@/common/plugins/components'
// 全局指令注册
import { setupDirectives } from '@/common/plugins/directives'
// 权限工具函数
import { hasAuth } from '@/common/utils/auth'

// 全局配置
Vue.prototype.$echarts = echarts
Vue.prototype.axios = axios
Vue.prototype.$qs = qs
Vue.prototype.$hasAuth = hasAuth

axios.defaults.withCredentials = true

window.toast = toast
window.Vue = Vue

// 使用插件
Vue.use(router)
Vue.use(auth, authConfig)
Vue.use(commPlugin)
Vue.use(ElementUI, {
    size: 'small'
})

// 配置路由守卫
setupRouter()

// 注册全局组件
setupComponents()

// 注册全局指令
setupDirectives()

import 'library/filters/currency'
import 'library/filters/formatDate'
import 'library/filters/unitMoney'
import 'library/filters/week'
import 'library/filters/compressImage'

new Vue({
    data() {
        return {
            previewUrl: '',
            previewVisible: false,
            deg: 0,
            size: 1,
        }
    },
    router,
    store,
    template: '<App/>',
    render: h => h(App)
}).$mount('#app')